import { useMemo } from 'react'
import { useZello } from 'hooks/zello/useZello'
import { ZELLO_BASE_URL } from 'lib/constants/zello'
import type { VoiceClient, VoiceClientContext } from '../types'

const CAPABILITIES = { sharedSession: false }

// Zello Work: the org's network is `zelloSubdomain`, the user logs on as
// their own id with the password /users/current returns.
export function useZelloAdapter({ enabled, org, orgId, currentUser, language }: VoiceClientContext): VoiceClient {
  const subdomain = enabled ? org?.zelloSubdomain : undefined
  const username = enabled ? currentUser?.id : undefined
  const password = enabled ? currentUser?.zelloPassword : undefined
  // Shares `ZELLO_BASE_URL` with the connectivity probe on purpose: the probe
  // exists to test this exact URL, so the two must not be able to drift.
  const serverUrl = `${ZELLO_BASE_URL}${subdomain || ''}`

  const zello = useZello({ serverUrl, username, password, language })

  const orgMatches = Boolean(orgId && org && String(org.id) === String(orgId))
  const ready = Boolean(enabled && orgMatches && subdomain && username && password)

  return useMemo(() => ({ ...zello, backend: 'zello' as const, ready, capabilities: CAPABILITIES }), [zello, ready])
}
